import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const MainHeader = ({ name }) => (
  <Box
    sx={{
      width: "100%",
      px: { xs: 2, sm: 4, md: 6, lg: 10 },
      pt: { xs: 6, md: 10 },
      pb: { xs: 3, md: 4 },
      borderBottom: "1px solid #e5e7eb",
      textAlign: "center",
    }}
  >
    <Typography
      sx={{
        fontSize: { xs: 28, sm: 36, md: 42 },
        fontWeight: 300,
        letterSpacing: "-0.03em",
        color: "#111827",
      }}
    >
      {name}
    </Typography>
  </Box>
);
